import {Api} from "./ApiConfig";

export const _Post = (url, data) => Api.post(url,data)
export const _Get = (url) => Api.get(url)
export const _Put = (url, data) => Api.put(url, data)